import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

import App from '../App';

const Root = ({ store, theme }) => (
  <Provider store={store}>
    <App theme={theme} />
  </Provider>
);

Root.propTypes = {
  theme: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
};

export default Root;
